import SettingsState from '../model/state/SettingsState';
import { FETCH_THRESHOLD_SETTINGS_SUCCESS, UPDATE_THRESHOLD_SETTINGS, FETCH_THRESHOLD_SETTINGS, SAVE_THRESHOLD_SETTINGS,
  SAVE_THRESHOLD_SETTINGS_SUCCESS, SAVE_THRESHOLD_SETTINGS_ERROR,
  SAVE_AUTO_SHUTOFF_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS_TAB,
  FETCH_NOTIFICATION_SETTINGS_SUCCESS, FETCH_NOTIFICATION_SETTINGS, UPDATE_NOTIFICATION_STATE, SAVE_NOTIFICATION_SETTINGS, SAVE_NOTIFICATION_SETTINGS_SUCCESS, SAVE_NOTIFICATION_SETTINGS_ERROR, FETCH_NOTIFICATION_SETTINGS_ERROR } from "constants/ActionTypes";
import { CustomAction } from "model/state";
import { SettingsPayload } from "actions";
import { AlarmSeverity } from 'model';

const initialState: SettingsState = {
  thresholds: {
    isSubmitting: false,
    settings: null,
  },
  notifications: {
    settings: [],
    isSubmitting: false,
    currentTab: AlarmSeverity.CRITICAL,
    isLoading: false,
  }
};

function settingsReducer(state: SettingsState | undefined = initialState, action: CustomAction<SettingsPayload>) {
  switch (action.type) {
    case FETCH_THRESHOLD_SETTINGS_SUCCESS: {
      return {
        ...state,
        thresholds: {
          ...state.thresholds,
          settings: action.payload?.settings || null
        }
      }
    }

    case FETCH_THRESHOLD_SETTINGS: {
      return {
        ...state,
        thresholds: {
          ...state.thresholds,
          settings: null,
        }
      }
    }

    case UPDATE_THRESHOLD_SETTINGS: {
      return {
        ...state,
        thresholds: {
          ...state.thresholds,
          settings: action.payload?.settings || null
        }
      }
    }

    case SAVE_THRESHOLD_SETTINGS:
    case SAVE_AUTO_SHUTOFF_SETTINGS: {
      return {
        ...state,
        thresholds: {
          ...state.thresholds,
          isSubmitting: true,
        }
      }
    }

    case SAVE_THRESHOLD_SETTINGS_SUCCESS:
    case SAVE_THRESHOLD_SETTINGS_ERROR:
      return {
        ...state,
        thresholds: {
          ...state.thresholds,
          isSubmitting: false,
        }
      }

    case UPDATE_NOTIFICATION_SETTINGS_TAB: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          currentTab: action.payload?.currentTab || AlarmSeverity.CRITICAL,
        }
      }
    }

    case FETCH_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          settings: initialState.notifications.settings,
          currentTab: initialState.notifications.currentTab,
          isLoading: true,
          device: action.payload?.device,
        }
      }
    }

    case FETCH_NOTIFICATION_SETTINGS_SUCCESS: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          settings: action.payload?.alarmSettings || initialState.notifications.settings,
          isLoading: false,
        }
      }
    }

    case FETCH_NOTIFICATION_SETTINGS_ERROR: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          settings: initialState.notifications.settings,
          isLoading: false,
        }
      }
    }

    case UPDATE_NOTIFICATION_STATE: {
      const newSettings = state.notifications.settings.map(data => data.alarm.id === action.payload?.alarmId ? ({
        ...data,
        ...action.payload?.alarmSettingsPayload,
        isDirty: true
      }) : data);

      return {
        ...state,
        notifications: {
          ...state.notifications,
          settings: newSettings,
        }
      }
    }

    case SAVE_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isSubmitting: true,
        }
      }
    }

    case SAVE_NOTIFICATION_SETTINGS_SUCCESS:
    case SAVE_NOTIFICATION_SETTINGS_ERROR:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          isSubmitting: false,
        }
      }

    default:
      return state
  }
}

export default settingsReducer;
